<template>
  <v-form ref="ACCIDENT_TRAVAIL" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="ACCIDENT_TRAVAIL">
      </section-header>

      <div class="pb-4" style="font-size: 14px; color: #E31F1C">
        Le taux accident du travail indiqué s'applique à tous les techniciens et correspond aux spécificités de votre secteur d'activité et de votre entreprise. Pour les artistes, seuls 70% de son taux est appliqué.
      </div>

      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <accident-travail-type v-if="isDisplayed('TYPE')"
                               ref="TYPE"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=type
                               @status=statusType
                               :required="isRequired('TYPE')"
                               :contextId=accidentTravail.id
                               :readOnly="readOnly('TYPE')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </accident-travail-type>
        <accident-travail-code-risque v-if="isDisplayed('CODE_RISQUE')"
                                      ref="CODE_RISQUE"
                                      :theme="theme"
                                      :showMissing="showMissing"
                                      v-model:value=codeRisque
                                      @status=statusCodeRisque
                                      :over-ride-placeholder=placeholderCodeRisque
                                      :required="isRequired('CODE_RISQUE')"
                                      :contextId=accidentTravail.id
                                      :readOnly="readOnly('CODE_RISQUE')"
                                      :objType=objType
                                      :fiche=fiche
                                      :sectionName="sectionName">
        </accident-travail-code-risque>
        <accident-travail-taux-patronal v-if="isDisplayed('TAUX_PATRONAL')"
                                        ref="TAUX_PATRONAL"
                                        :theme="theme"
                                        :showMissing="showMissing"
                                        v-model:value=tauxPatronal
                                        @status=statusTauxPatronal
                                        :required="isRequired('TAUX_PATRONAL')"
                                        :contextId=accidentTravail.id
                                        :readOnly="readOnly('TAUX_PATRONAL')"
                                        :objType=objType
                                        :fiche=fiche
                                        :sectionName="sectionName">
        </accident-travail-taux-patronal>
        <accident-travail-date-effet v-if="isDisplayed('DATE_EFFET')"
                                     ref="DATE_EFFET"
                                     :theme="theme"
                                     :showMissing="showMissing"
                                     v-model:value=dateEffet
                                     @status=statusDateEffet
                                     :periods='periodDateEffet'
                                     :required="isRequired('DATE_EFFET')"
                                     :contextId=accidentTravail.id
                                     :readOnly="readOnly('DATE_EFFET')"
                                     :objType=objType
                                     :fiche=fiche
                                     :sectionName="sectionName">
        </accident-travail-date-effet>
        <accident-travail-source v-if="isDisplayed('SOURCE')"
                                 ref="SOURCE"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=source
                                 @status=statusSource
                                 :required="isRequired('SOURCE')"
                                 :contextId=accidentTravail.id
                                 :readOnly="readOnly('SOURCE')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </accident-travail-source>

        <v-file-input v-model="file"
                      :disabled="progress"
                      :accept="acceptedFiles"
                      :label="fileInputLabel">
        </v-file-input>

      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
import SectionAccidentTravail from '@/generated/sections/SectionAccidentTravail.vue';
import { defineComponent } from "vue";
import {mimeTypes} from "@/framework/files/helpers/FileTypes.ts";
import Files from "@/generated/classes/Files.ts";
import AccidentTravail from "@/generated/classes/AccidentTravail";

export default defineComponent({
  components: {},
  extends: SectionAccidentTravail,
  data() {
    const file: File | null = null;
    return {
      fileInputLabel: 'Choisir un fichier',
      progressLabel: "Changement en cours",
      progress: false,
      file,
      loading: false,
      uploadAfterSave: false,
    };
  },
  watch: {
    editAccidentTravail: {
      deep: true,
      handler(value: AccidentTravail) {
        if (!this.uploadAfterSave) {
          return;
        }

        if (this.file == null) {
          this.uploadAfterSave = false;
          return;
        }

        const accidentTravailId = value?.id ?? 0;

        if (accidentTravailId > 0) {
          this.uploadAfterSave = false;
          this.submitFile(accidentTravailId);
        }
      }
    }
  },
  computed: {
    acceptedFiles(): string {
      let res = 'pdf'
      mimeTypes.forEach(m => {
        if (m.type == 'pdf') {
          res = m.mime;
        }
      })
      return res;
    }
  },
  methods: {
    readOnly (value: string): boolean {
      let res = false;
      if (this.readOnlyMap.size == 0) {
        this.readOnlyMap.set("TYPE", true);
        this.readOnlyMap.set("CODE_RISQUE", !this.editAccidentTravail.canUpdate);
        this.readOnlyMap.set("TAUX_PATRONAL", !this.editAccidentTravail.canUpdate);
        this.readOnlyMap.set("DATE_EFFET", !this.editAccidentTravail.canUpdate);
        this.readOnlyMap.set("SOURCE", true);
      }
      const readOnly = this.readOnlyMap.get(value);
      if (readOnly != undefined) {
        res = readOnly;
      }
      return res;
    },
    isDisplayed (value: string): boolean {
      let res = true;
      if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
        this.displayMap.set("TYPE", true);
        this.displayMap.set("CODE_RISQUE", true);
        this.displayMap.set("TAUX_PATRONAL", true);
        this.displayMap.set("DATE_EFFET", true);
        this.displayMap.set("SOURCE", this.editAccidentTravail.id > 0);
      }
      const display = this.displayMap.get(value);
      if (display != undefined) {
        res = display;
      }
      return res;
    },
    submitFile(accidentTravailId: number): Promise<void> {
      if (this.file == null || accidentTravailId <= 0) {
        return Promise.resolve();
      }
      this.loading = true;
      this.progress = true;

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('service', 'AccidentTravail');
      formData.append('objId', accidentTravailId.toString());

      return Files.upload(formData)
          .then(() => {
            this.file = null;
          })
          .finally(() => {
            this.loading = false;
            this.progress = false;
          });
    },
    sectionSave(): void {
      if (!this.checkFields()) {
        return;
      }

      if (this.file != null) {
        if (this.refAccidentTravail.id > 0) {
          this.submitFile(this.refAccidentTravail.id);
          this.save();
        } else {
          this.uploadAfterSave = true;
          this.save();
        }
      } else {
        this.save();
      }
    }
  }
})

</script>
